import {ReactElement} from 'react';
import classnames from 'classnames';
import Rating from '@frontend/ui-kit/Components/Rating';
import Text, {TEXT_TYPES} from '@frontend/ui-kit/Components/Text';
import {LOCALES_BY_LANGUAGE} from '../../../constants';
import {formatDate} from '../../../utils';
import translationService from '../../../translationService';
import './index.scss';

type Props = {
    title: string,
    rating: number,
    text: string,
    date: string,
    logo: string,
    className?: string
}

const Feedback = ({title, rating, text, date, logo, className}: Props): ReactElement => {
    const currentLocale = LOCALES_BY_LANGUAGE[translationService.getLanguage()];
    const formattedDate = formatDate(new Date(date), 'MM/dd/yyyy', {locale: currentLocale});

    return (
        <div className={classnames('product-info-feedback', className)}>
            <div className='product-info-feedback-body'>
                <Text type={TEXT_TYPES.helperBold} className='product-info-feedback__title'>{title}</Text>
                <Rating rating={rating} className='product-info-feedback__rating' size={10}/>
                <Text type={TEXT_TYPES.helper} className='product-info-feedback__text'>{text}</Text>
            </div>

            <div className='product-info-feedback-data'>
                <Text type={TEXT_TYPES.helper} className='product-info-feedback-data__date'>
                    {formattedDate}
                </Text>
                <img src={logo} className='product-info-feedback-data__logo' alt='logo'/>
            </div>
        </div>
    );
};

export {Feedback as TestableFeedback};
export default Feedback;
